import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Input, ViewChild, ElementRef } from '@angular/core';
import { AbstractCustomControl, MakeProvider } from "../abstract-custom-control";
import { RadioButtonItem } from './radio-button-item';

@Component({
    selector: 'yt-radio-buttons-group',
    templateUrl: './radio-buttons-group.component.html',
    providers: [ MakeProvider(RadioButtonsGroupComponent) ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RadioButtonsGroupComponent extends AbstractCustomControl<any> {
    constructor(
        protected changeDetectorRef: ChangeDetectorRef
    ){
        super(changeDetectorRef);
    }

    radioGroupName: string = 'rb' + parseInt((Math.random() * 1000).toFixed(0));
    //selectedValue: any = null;

    @Input() Items: RadioButtonItem[];    

    ngOnInit(){
        
    }

    SetValue(value: any){
        //this.value = value.target.value;
        //this.selectedValue = value.target.value;
        //this.changeDetectorRef.markForCheck();
    }

    writeValue(value){
        super.writeValue(value);
        //this.selectedValue = value;
        this.changeDetectorRef.markForCheck();
    }

    setDisabledState(isDisabled: boolean){
        super.setDisabledState(isDisabled);       
        this.changeDetectorRef.markForCheck();
    }
}